
import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Register from "./Components/Register/Register";
import Login from "./Components/Login/Login";
import Dashboard from "./Components/Dashboard/Dashboard";
import Layout from "./Components/Side-Navbar/Layout";
import Lead from "./Components/Lead Page/Lead";
import Task from "./Components/Task page/Task";
import Note from "./Components/Note Page/Note";
import Reminder from "./Components/Reminder Page/Reminder";
import PrivateRoute from "./Components/routes/PrivateRoute";
import CreateAccount from "./Components/Account/Create-Account";
import ViewAccount from "./Components/Account/ViewAccount";
import EmailConfig from "./Components/GeneralSettings/EmailConfig";
import EmailTemplates from "./Components/Templetes/EmailTempletes";
import ProfilePage from "./Components/Profile/Profile";
import Todo from "./Components/Todo/Todo";
import Meeting from "./Components/Meeting page/Meeting";
import Calendar from "./Components/Calender/EventCalendar";
import BlacklistPage from "./Components/Blacklist/Blacklist";
import LeadLabel from "./Components/Attribute/LeadLabel";
import Greeting from "./Components/Greeting/Greeting";
import SMSConfig from "./Components/GeneralSettings/SMSConfig";
import SMSTemplates from "./Components/Templetes/SMSTempletes";
import IvrIntegration from "./Components/GeneralSettings/IvrIntegration";
import ResetPassword from "./Components/Login/ResetPassword";
import NotFoundPage from "./Components/NotFoundPage/NotFoundPage";
import Customer from "./Components/Customer/Customer";
import AccountStatement from "./Components/Account/AccountStatement";
import WebSetting from "./Components/GeneralSettings/WebSetting";
import LeadStatus from "./Components/Attribute/LeadStatus";
import TaskStatus from "./Components/Attribute/TaskStatus";
import TaskLabel from "./Components/Attribute/TaskLabel";
import LeadSource from "./Components/Attribute/LeadSource";
import GreetingTemplates from "./Components/Templetes/GreetingTemplates";
import Invoice from "./Components/Invoice/Invoice";
import ViewInvoice from "./Components/Invoice/ViewInvoice";
import useAutoLogout from "./Components/Login/useAutoLogout";
import Issues from "./Components/Issues/Issues";
import { useNavigate } from "react-router-dom";
import IssueStatus from "./Components/Attribute/IssueStatus";
import IssueType from "./Components/Attribute/IssueType";
import Environment from "./Components/Attribute/Environment";
import Severity from "./Components/Attribute/Severity";
import FacebookIntegration from "./Components/GeneralSettings/FacebookIntegration";
import KeyIntegration from "./Components/GeneralSettings/KeyIntegration";
import Leave from "./Components/Attendance/Leave";
import AttendanceCalendar from "./Components/Attendance/Attendance";
import WorkingPolicy from "./Components/WorkingPolicy/WorkingPolicy";
import ClickToCall from "./Components/GeneralSettings/ClickToCall";
import GoogleFormIntegration from "./Components/GeneralSettings/GoogleFormIntegration";
import LeadTasksPage from "./Components/Task page/LeadTaskPage";
// import { WebRTCProvider } from "./Components/context/WebRTCContext"; // Add this import
import WhatsAppConfig from "./Components/GeneralSettings/WhatsappIntegration";
import Chat from "./Components/Chat/Chat";
import WhatsAppSms from "./Components/Chat/WhatsappSms";
import WhatsAppReport from "./Components/Chat/WhatsappReport";

import SendTemplate from "./Components/Chat/SendTemplate";
import CreateWhatsappTemplate from "./Components/Chat/CreateWhatsappTemplate";
import AutoReply from "./Components/Chat/AutoReply";
import LeadReportToday from "./Components/Lead Page/LeadReportToday";

// Import new public components
import HomePage from "./WebsiteComponents/HomePage";
import AboutPage from "./WebsiteComponents/AboutPage";
import PublicLayout from "./PublicLayout/PublicLayout";
import Contact from "./WebsiteComponents/Contact";
import Blogs from "./WebsiteComponents/blogs/Blogs";
import BlogPost from "./WebsiteComponents/blogs/BlogPost";

import FeaturesPage from "./WebsiteComponents/WebsitePages/FeaturesPage";
import Pricing from "./WebsiteComponents/WebsitePages/Pricing";
import PrivacyPolicy from "./WebsiteComponents/WebsitePages/PrivacyPolicy";
import TermsAndConditions from "./WebsiteComponents/WebsitePages/TermsAndConditions";
import Healthcare from "./WebsiteComponents/WebsiteSolution/Healthcare";
import Education from "./WebsiteComponents/WebsiteSolution/Eduaction";
import RealEstate from "./WebsiteComponents/WebsiteSolution/RealEstate";
import Insurance from "./WebsiteComponents/WebsiteSolution/Insurance";
import Banking from "./WebsiteComponents/WebsiteSolution/Banking";
import Technology from "./WebsiteComponents/WebsiteSolution/Technology";
import SalesGod from "./Components/Dashboard/SalesGod";
import LeadFunnel from "./Components/Dashboard/LeadFunnel";
import WhatsAppTemplate from "./Components/Chat/WhatsappTemplate";
import IncomingMode from "./Components/Dashboard/IncomingMode";


// 👇 NEW IMPORT ADDED HERE (Adjust the folder path if you saved it somewhere else)
import OAuthCallback from "./Components/GeneralSettings/OAuthCallback";
import WhastappNotification from "./Components/Chat/whastappNotification";
import Appointment from "./Components/Attribute/Appointment";
import Transcriptionconfig from "./Components/GeneralSettings/Transcriptionconfig";
import Publicpage from "./WebsiteComponents/Publicpage";
import LeadConfig from "./Components/Attribute/LeadConfig";
import { IncomingModeProvider } from "./Components/context/IncomingModeContext";
import PublicChatbotWidget from "./Components/PublicChatbotWidget";
import WorkflowAutomation from "./Components/GeneralSettings/WorkflowAutomation";
import Videocall from "./WebsiteComponents/WebsitePages/Videocall";
import Recentleads from "./Components/Dashboard/Recentleads";
import Videocallconfig from "./Components/GeneralSettings/Videocallconfig";
import Adminchat from "./Components/Chatbot/adminchat";
import ContactsPage from "./Components/Contact/Contact";
function App() {
  const location = useLocation();
  const timeLeft = useAutoLogout(); // in milliseconds
  const navigate = useNavigate();

  const hideTimerOnRoutes = ["/", "/register", "/reset-password", "/oauth-callback"]; // Added callback to hide timer
  const shouldShowTimer = !hideTimerOnRoutes.includes(location.pathname);

  const formatTime = (ms) => {
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, "0");
    const seconds = String(totalSeconds % 60).padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "logout") {
        // 🔒 Log out this tab too
        localStorage.removeItem("token");
        localStorage.removeItem("userPermissions");
        localStorage.removeItem("sidebarDropdownStates");
        navigate("/");
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return (
    // <WebRTCProvider> {/* Wrap your entire app with WebRTCProvider */}
    <IncomingModeProvider>
    <div className="App dark:bg-gray-900 dark:text-white relative">
      <WhastappNotification />
      <PublicChatbotWidget />

      {shouldShowTimer && (
        <div className="fixed top-0 right-4 bg-gray-200 text-black dark:bg-gray-800 dark:text-white px-3 rounded-md text-sm z-[9] shadow-md">
          Auto logout in: {formatTime(timeLeft)}
        </div>
      )}

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        style={{ zIndex: 9999 }}
      />

      <Routes>
        {/* public routes  */}
        <Route
          path="/"
          element={
            <PublicLayout>
              <HomePage />
            </PublicLayout>
          }
        />
        <Route
          path="/about-us"
          element={
            <PublicLayout>
              <AboutPage />
            </PublicLayout>
          }
        />
        <Route
          path="/public-page"
          element={
            <Publicpage />
          }
        />

        <Route
          path="/contact"
          element={
            <PublicLayout>
              <Contact />
            </PublicLayout>
          }
        />
        <Route
          path="/blogs"
          element={
            <PublicLayout>
              <Blogs />
            </PublicLayout>
          }
        />
        <Route
          path="/blogs/:id"
          element={
            <PublicLayout>
              <BlogPost />
            </PublicLayout>
          }
        />
       <Route
          path="/video-call"
          element={
              <Videocall />
          }
        />

        <Route
          path="/pricing"
          element={
            <PublicLayout>
              <Pricing />
            </PublicLayout>
          }
        />
        <Route
          path="/features"
          element={
            <PublicLayout>
              <FeaturesPage />
            </PublicLayout>
          }
        />
        <Route
          path="/privacy-policy"
          element={
            <PublicLayout>
              <PrivacyPolicy />
            </PublicLayout>
          }
        />
        <Route
          path="/terms-and-conditions"
          element={
            <PublicLayout>
              <TermsAndConditions />
            </PublicLayout>
          }
        />

        {/* solution section */}

        <Route
          path="/solutions/healthcare"
          element={
            <PublicLayout>
              <Healthcare />
            </PublicLayout>
          }
        />
        <Route
          path="/solutions/education"
          element={
            <PublicLayout>
              <Education />
            </PublicLayout>
          }
        />
        <Route
          path="/solutions/real-estate"
          element={
            <PublicLayout>
              <RealEstate />
            </PublicLayout>
          }
        />
        <Route
          path="/solutions/insurance"
          element={
            <PublicLayout>
              <Insurance />
            </PublicLayout>
          }
        />
        <Route
          path="/solutions/banking-finance"
          element={
            <PublicLayout>
              <Banking />
            </PublicLayout>
          }
        />
        <Route
          path="/solutions/technology"
          element={
            <PublicLayout>
              <Technology />
            </PublicLayout>
          }
        />

        {/* Pages without Sidebar */}
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* 👇 NEW ROUTE ADDED HERE */}
        <Route path="/oauth-callback" element={<OAuthCallback />} />

        {/* Pages with Sidebar */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Layout>
                <Dashboard />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="//dashboard/sales-god"
          element={
            <PrivateRoute>
              <Layout>
                <SalesGod />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/dashboard/lead-funnel"
          element={
            <PrivateRoute>
              <Layout>
                <LeadFunnel />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/dashboard/incoming-mode"
          element={
            <PrivateRoute>
              <Layout>
                <IncomingMode />
              </Layout>
            </PrivateRoute>
          }
        />


         <Route
          path="/dashboard/recentleads"
          element={
            <PrivateRoute>
                <Recentleads />
            </PrivateRoute>
          }
        />

        <Route
          path="/lead/lead"
          element={
            <PrivateRoute>
              <Layout>
                <Lead />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/appointment-config"
          element={
            <PrivateRoute>
              <Layout>
                <Appointment />
              </Layout>
            </PrivateRoute>
          }
        />


        <Route
          path="/tasks"
          element={
            <PrivateRoute>
              <Layout>
                <Task />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/lead-tasks"
          element={
            <PrivateRoute>
              <Layout>
                <LeadTasksPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/issues"
          element={
            <PrivateRoute>
              <Layout>
                <Issues />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/note"
          element={
            <PrivateRoute>
              <Layout>
                <Note />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/reminder"
          element={
            <PrivateRoute>
              <Layout>
                <Reminder />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/meeting"
          element={
            <PrivateRoute>
              <Layout>
                <Meeting />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/createAccount"
          element={
            <PrivateRoute>
              <Layout>
                <CreateAccount />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/viewAccount"
          element={
            <PrivateRoute>
              <Layout>
                <ViewAccount />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/emailConfig"
          element={
            <PrivateRoute>
              <Layout>
                <EmailConfig />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/emailTemplates"
          element={
            <PrivateRoute>
              <Layout>
                <EmailTemplates />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <PrivateRoute>
              <Layout>
                <ProfilePage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/todo"
          element={
            <PrivateRoute>
              <Layout>
                <Todo />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/calendar"
          element={
            <PrivateRoute>
              <Layout>
                <Calendar />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/blacklist"
          element={
            <PrivateRoute>
              <Layout>
                <BlacklistPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/leadLabel"
          element={
            <PrivateRoute>
              <Layout>
                <LeadLabel />
              </Layout>
            </PrivateRoute>
          }
        />
        {/* lead report */}
        <Route
          path="/lead/lead/report"
          element={
            <PrivateRoute>
              <Layout>
                <LeadReportToday />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/leadStatus"
          element={
            <PrivateRoute>
              <Layout>
                <LeadStatus />
              </Layout>
            </PrivateRoute>
          }
        />


        <Route
          path="/leadconfig"
          element={
            <PrivateRoute>
              <Layout>
                <LeadConfig />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/leadSource"
          element={
            <PrivateRoute>
              <Layout>
                <LeadSource />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/taskStatus"
          element={
            <PrivateRoute>
              <Layout>
                <TaskStatus />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/issueStatus"
          element={
            <PrivateRoute>
              <Layout>
                <IssueStatus />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/issueType"
          element={
            <PrivateRoute>
              <Layout>
                <IssueType />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/taskLabel"
          element={
            <PrivateRoute>
              <Layout>
                <TaskLabel />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/severityAttributes"
          element={
            <PrivateRoute>
              <Layout>
                <Severity />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/environmentAttributes"
          element={
            <PrivateRoute>
              <Layout>
                <Environment />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/greeting"
          element={
            <PrivateRoute>
              <Layout>
                <Greeting />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/smsConfig"
          element={
            <PrivateRoute>
              <Layout>
                <SMSConfig />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/smsTemplates"
          element={
            <PrivateRoute>
              <Layout>
                <SMSTemplates />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/greetingTemplates"
          element={
            <PrivateRoute>
              <Layout>
                <GreetingTemplates />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/googleForm"
          element={
            <PrivateRoute>
              <Layout>
                <GoogleFormIntegration />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/ivrIntegration"
          element={
            <PrivateRoute>
              <Layout>
                <IvrIntegration />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/whatsappConfig"
          element={
            <PrivateRoute>
              <Layout>
                <WhatsAppConfig />
              </Layout>
            </PrivateRoute>
          }
        />



        <Route
          path="/chat"
          element={
            <PrivateRoute>
              <Layout>
                <Chat />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/auto-reply"
          element={
            <PrivateRoute>
              <Layout>
                <AutoReply />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/whatsappSms"
          element={
            <PrivateRoute>
              <Layout>
                <WhatsAppSms />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/whatsappReport"
          element={
            <PrivateRoute>
              <Layout>
                <WhatsAppReport />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/whatsappTemplates"
          element={
            <PrivateRoute>
              <Layout>
                <WhatsAppTemplate />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/createWhatsappTemplate"
          element={
            <PrivateRoute>
              <Layout>
                <CreateWhatsappTemplate />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/sendTemplate"
          element={
            <PrivateRoute>
              <Layout>
                <SendTemplate />
              </Layout>
            </PrivateRoute>
          }
        />
       
        <Route
          path="/facebookIntegration"
          element={
            <PrivateRoute>
              <Layout>
                <FacebookIntegration />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/keyIntegration"
          element={
            <PrivateRoute>
              <Layout>
                <KeyIntegration />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/clickToCall"
          element={
            <PrivateRoute>
              <Layout>
                <ClickToCall />
              </Layout>
            </PrivateRoute>
          }
        />


        <Route
          path="/ai-configuration"
          element={
            <PrivateRoute>
              <Layout>
                <Transcriptionconfig />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/video-config"
          element={
            <PrivateRoute>
              <Layout>
                <Videocallconfig />
              </Layout>
            </PrivateRoute>
          }
        />
                <Route
          path="/support-settings"
          element={
            <PrivateRoute>
              <Layout>
                <Adminchat />
              </Layout>
            </PrivateRoute>
          }
        />

        <Route
          path="/workflow-automation"
          element={
            <PrivateRoute>
              <Layout>
                <WorkflowAutomation/>
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/workingPolicy"
          element={
            <PrivateRoute>
              <Layout>
                <WorkingPolicy />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/customer"
          element={
            <PrivateRoute>
              <Layout>
                <Customer />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/accountStatement"
          element={
            <PrivateRoute>
              <Layout>
                <AccountStatement />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/webSetting"
          element={
            <PrivateRoute>
              <Layout>
                <WebSetting />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/invoice"
          element={
            <PrivateRoute>
              <Layout>
                <Invoice />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/ViewInvoice"
          element={
            <PrivateRoute>
              <Layout>
                <ViewInvoice />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/attendance"
          element={
            <PrivateRoute>
              <Layout>
                <AttendanceCalendar />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/leave"
          element={
            <PrivateRoute>
              <Layout>
                <Leave />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route
          path="/contacts"
          element={
            <PrivateRoute>
              <Layout>
                <ContactsPage />
              </Layout>
            </PrivateRoute>
          }
        />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>

      {/* Add CallControls component (will only show when there's an active call) */}
      {/* <CallControls /> */}
    </div>
    </IncomingModeProvider>
    // </WebRTCProvider>
  );
}

export default App;